<template lang="">

<div>
    <!-------------------------------- Bloc Articles -------------------------------->


 <v-toolbar color="#0B87BA" flat dense>
          <v-col
            cols="6"
            lg="6"
            xl="6"
            class="pa-0 font_color text-left"
          >
            {{title?title:"SELECTIONNER UN PRODUIT"}}
          </v-col>

    <v-col cols="6" lg="6" xl="4" offset-xl="2"  class="pa-0 text-right">
      <v-btn v-if="mode !== 'visualisation'" :disabled="disabled" class="btnBold"  color="#FF9900" dark rounded @click="dialog=true" >
        <v-icon left> fa fa-plus </v-icon>
            <div >
              Ajouter un produit
            </div>
      </v-btn>
     </v-col>
    </v-toolbar>

        <Popup :dialog="dialog" text="" actions="" heightProp="" widthProp="70vW"  @emitDialog="dialog = $event" showClose="true">
                <!-- Formulaire articles -->
    <v-col cols="12" sm="12" class="pb-0 pl-8 pr-16 ">
      <form  @submit.prevent="submit">



        <v-toolbar color="#0B87BA" flat dense>
          <v-col
            cols="6"
            lg="6"
            xl="2"
            class="pa-0 font_color text-left"
          >
            AJOUTER UN PRODUIT
          </v-col>

        </v-toolbar>




            <v-col cols="12" sm="12" class="pt-5">
              <div class="text-left">DESIGNATION DU PRODUIT OU CODE NAVISION*

              </div>

                <v-autocomplete
                :items="articles_retour"
                item-value="id_article_retour"
                item-text="article"
                return-object
                v-model="article_retour"
                outlined
                dense
                color="#CFCFCF"
                :search-input.sync="searchInput"
                no-data-text="Aucun produit trouvé"
                hide-details
                cache-items
              >
              </v-autocomplete>

          <!-- message d'erreur -->
                      <div class="errorMsg" v-if="$v.article_retour.id_article_retour.$error && $v.article_retour.id_article_retour.required == false">
            Renseignez le produit.
          </div>
            <!-- message d'erreur -->

            </v-col>

            <v-col cols="12" sm="6" class="pt-5">
              <div class="text-left">
                  QUANTITE*

             </div>
              <v-text-field label="" single-line outlined dense v-model="article_retour.article_quantite" hide-details   ></v-text-field>
                                          <div class="errorMsg" v-if="$v.article_retour.article_quantite.$error && $v.article_retour.article_quantite.required == false">
                    Renseigner la quantité.
                </div>

                <div class="errorMsg" v-if="$v.article_retour.article_quantite.$error && $v.article_retour.article_quantite.numeric == false">
                    Renseigner seulement une valeur numérique.
                </div>
            </v-col>







                  <v-col cols="12" sm="12"  class="">
              <v-btn :disabled="disabled" class="btnBold"  color="#FF9900" dark rounded type="submit" >
        <v-icon left> fa fa-plus </v-icon>
            <div >
              Ajouter ce produit
            </div>
      </v-btn>
      </v-col>

    </form>

        </v-col>
      </Popup>

        <Popup :dialog="dialogDelete" text="Supprimer ce produit ?" actions="" heightProp="" widthProp="" @emitDialog="dialog = $event" showClose="false">
                     <v-card-actions class="mb-10">

              <v-btn class="actions mr-10" color="#0B87BA" width="100px"  large dark rounded @click="closeDelete">Non</v-btn>
              <v-btn class="actions" color="#0B87BA" width="100px"  large dark rounded @click="deleteItemConfirm">Oui</v-btn>

            </v-card-actions>
        </Popup>
   <div v-if="retour_a_articles.length == 0 && mode == 'visualisation'" class="text-left font-weight-bold"> Aucun produit renseigné. </div>
  <div class="text-left pt-4 pb-5" v-if="retour_a_articles.length == 0">
           Merci d'ajouter au moins un produit
  </div>
      <v-col cols="12" sm="12" class="pb-0 pl-0 ">
        <v-data-table  v-if="retour_a_articles.length > 0"
          :headers="headers"
          :items="retour_a_articles"
          :items-per-page="10"
          class="elevation-1 mt-10"
        >
      <template v-if="mode !== 'visualisation'" v-slot:item.actions="{ item }">
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>


  </v-data-table>


  </v-col>




      <!-------------------------------- BLOC ARTICLES -------------------------------->
    </div>

</template>
<script>
import {
  required,
  numeric
} from "vuelidate/lib/validators";
 import Popup from "@/components/shared/Popup";
 import apiArticlesRetour from "@/api/articles_retour";
export default {
  props: {
    retour_a_articles: {
      type: Array,
      default: () => [],
    },
    mode: [String],
    title: [String],
  },
  components: {
    Popup,
  },
  data() {
    return {
        message: "Supprimer ce produit ?",
        headers: [
        { text: 'Référence', align: 'start', value: 'ref_product', sortable: false },
        { text: 'Numéro', align: 'start', value: 'num_product', sortable: false },
        { text: 'Quantité', value: 'quantity', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      dialogDelete: false,
      disabled: false,
      dialog: false,
      height: "",
      width: "",
      articles_retour: [],
      article_retour: {
        id_article_retour: null,
        article_quantite: null,
        article: null,
      },
      nbResult : process.env.VUE_APP_NB_DISPLAY,
      searchInput: "",
    };
  },
  validations: {
    article_retour: {
      id_article_retour: {
        required
      },
      article_quantite: {
        required,
        numeric,
      },
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.dialog = false;

        // Split the article string into reference and number
        const articleStr = this.article_retour.article || '';
        const dashIndex = articleStr.lastIndexOf(' - ');
        let ref_product = '';
        let num_product = '';

        if (dashIndex !== -1) {
          ref_product = articleStr.substring(0, dashIndex).trim();
          num_product = articleStr.substring(dashIndex + 3).trim();
        } else {
          ref_product = articleStr;
        }

        this.retour_a_articles.push({
          id_article_retour: this.article_retour.id_article_retour,
          article: this.article_retour.article,
          ref_product: ref_product,
          num_product: num_product,
          article_quantite: this.article_retour.article_quantite,
        });

        this.article_retour = {
          id_article_retour: null,
          article_quantite: null,
        }
        this.searchArticle("" ,this.nbResult);
        this.$v.$reset();
      }


    },
    searchArticle(query,nbResult){
      apiArticlesRetour.getArticlesRetour(nbResult,query).then((res) => {
      this.articles_retour = res.data.articles_retour

      this.articles_retour.forEach((element) => {
        element["article"] = element["article"] + ' - ' + element["reference"];
      })
      })

    },
    deleteItem (item) {
      this.editedIndex = this.retour_a_articles.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.retour_a_articles.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
  },
    watch:{
      searchInput(newValue){

        this.searchArticle(newValue,this.nbResult)

      },
    },
  mounted() {
    this.searchArticle("" ,this.nbResult);
    if (this.mode == "visualisation") {
      this.headers = [
        { text: 'Référence', align: 'start', value: 'ref_product', sortable: false },
        { text: 'Numéro', align: 'start', value: 'num_product', sortable: false },
        { text: 'Quantité', value: 'article_quantite', sortable: false },
      ];
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables";
.calendar-field {
  width: 20%;
}

img {
  width: 29px;
  height: 28px;
}

.font_color {
  font-weight: bold;
  color: #ffffff;
}

.width-50 {
  width: 30%;
}

.addPersonne {
  border-style: dashed;
  border-color: blue;
  color: blue;
}

.btnBold {
  font-weight: bold;
}

.errorMsg {
  text-align: left;
  color: red;
  /* margin-bottom: 0.7em;
  margin-top: 0.7em; */
}

.actions{
    padding: 2% 5%;
    font-weight: bold;
    font-size: 1.2em;
}

::v-deep .menu-chips.theme--dark.v-list,
.v-chip.v-chip--clickable.v-chip--no-color.v-chip--pill.v-chip--removable.theme--light.v-size--default,
::v-deep .v-icon.notranslate.v-chip__close.v-icon--link.v-icon--right.mdi.mdi-delete.theme--light {
  background: $background-color-blue;
  color: #fff;
}
</style>
